var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex",attrs:{"id":"adminSection"}},[_c('router-view'),(_vm.$route.name != 'login')?_c('toolsHeader',{attrs:{"id":"mainNavbarAdmin"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }